import { render, staticRenderFns } from "./ReportsTable.vue?vue&type=template&id=06cdda7a&scoped=true&"
import script from "./ReportsTable.vue?vue&type=script&lang=js&"
export * from "./ReportsTable.vue?vue&type=script&lang=js&"
import style0 from "./ReportsTable.vue?vue&type=style&index=0&id=06cdda7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cdda7a",
  null
  
)

export default component.exports